import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Home from "../page/home/home";
import Header from "../header";
import Login from "../page/login/login";
import UserInfor from "../page/userinfor/";
import Personal from "../page/personal/";
import ForgotPassword from "../page/login/forgotpassword";

import PublishVideo from "../page/content/video/publishVideo/";
import PublishTutorial from "../page/content/tutorial/publishTutorial/";
import PublishPaper from "../page/content/paper/publishPaper/";

import PublishComputing from "../page/aiExchange/Computing/publishComputing/";
import PublishDataset from "../page/aiExchange/Dataset/publishDataset/";
import PublishServer from "../page/aiExchange/Server/publishServer/";

import Videotutorials from "../page/homelist/videotutorials/";
import VideoDetail from "../page/homelist/videotutorials/videoDetail";
import Papertutorials from "../page/homelist/papertutorials";
import PaperDetail from "../page/homelist/papertutorials/paperDetail";

import Tutorial from "../page/homelist/tutorial/";
import TutorialDetail from "../page/homelist/tutorial/tutorialDetail";
import Computationaltrading from "../page/homelist/computationaltrading/";
import ComputaDetail from "../page/homelist/computationaltrading/conputerDetail";
import DatasetDetail from "../page/homelist/data/datasetDetail";
import ServiceDetail from "../page/homelist/service/serviceDetail";

import IndustryNews from "../page/homelist/industrynews";
import IndustryNewsDetail from "../page/homelist/industrynews/industrynewsDetail";
import Tool from "../page/homelist/tool/";
import Data from "../page/homelist/data/";
import Service from "../page/homelist/service/";
// import Recharge from "../page/personal/right/finance/recharge";
import BankCard from "../page/personal/right/finance/components/BankCard/BankCard.js";
import BankCardConfirm from "../page/personal/right/finance/components/BankCard/BankCardConfirm.js";
import NotFound from "./notFound";
import { setupAuthInterceptor } from "@/utils/authInterceptor";
import Verify from "../page/personal/right/finance/components/Verify/Verify";
import PayConfirm from "../page/homelist/computationaltrading/components/PayConfirm/PayConfirm";

const routes = [
  {
    path: "/",
    element: <Home />,
    title:
      "渐风AI,AI技术长期发展平台,AI算力共享,AI技术教程,AI视频课,AI数据集,AI企业名录,AI热门工具,AI工具集,AI新闻,人工智能资讯",
  },
  {
    path: "/home",
    element: <Home />,
    title:
      "渐风AI,AI技术长期发展平台,AI算力共享,AI技术教程,AI视频课,AI数据集,AI企业名录,AI热门工具,AI工具集,AI新闻,人工智能资讯",
  },
  { path: "/personal", element: <Personal />, title: "个人中心 - 渐风AI" },
  { path: "/userInfor", element: <UserInfor />, title: "用户信息 - 渐风AI" },
  {
    path: "/publishVideo",
    element: <PublishVideo />,
    title: "发布视频 - 渐风AI",
  },
  {
    path: "/publishTutorial",
    element: <PublishTutorial />,
    title: "发布教程 - 渐风AI",
  },
  {
    path: "/publishComputing",
    element: <PublishComputing />,
    title: "发布算力 - 渐风AI",
  },
  {
    path: "/publishPaper",
    element: <PublishPaper />,
    title: "发布论文 - 渐风AI",
  },
  {
    path: "/publishDataset",
    element: <PublishDataset />,
    title: "发布数据集 - 渐风AI",
  },
  {
    path: "/publishServer",
    element: <PublishServer />,
    title: "发布服务 - 渐风AI",
  },
  {
    path: "/videotutorials",
    element: <Videotutorials />,
    title: "视频教程,人工智能AI技术专业在线视频 - 渐风AI",
  },
  {
    path: "/video_detail",
    element: <VideoDetail />,
    title: "视频详情 - 渐风AI",
  },
  {
    path: "/tutorial",
    element: <Tutorial />,
    title: "教程,人工智能AI技术垂直技术内容 - 渐风AI",
  },
  {
    path: "/tutorial_detail",
    element: <TutorialDetail />,
    title: "教程详情 - 渐风AI",
  },
  {
    path: "/papertutorials",
    element: <Papertutorials />,
    title: "论文教程,人工智能AI论文分享 - 渐风AI",
  },
  {
    path: "/paper_detail",
    element: <PaperDetail />,
    title: "论文详情 - 渐风AI",
  },
  {
    path: "/computationaltrading",
    element: <Computationaltrading />,
    title: "算力交易,GPU,智算,大模型,LLM部署资源在线交易平台,  - 渐风AI",
  },
  {
    path: "/computa_detail",
    element: <ComputaDetail />,
    title: "算力详情 - 渐风AI",
  },
  {
    path: "/tool",
    element: <Tool />,
    title:
      "AI工具,AI绘画,AI视频,AI写作,AI论文,AI视频,AI多模态,AI翻译工具集合 - 渐风AI",
  },
  {
    path: "/dataset_list",
    element: <Data />,
    title: "数据集,人工智能,AI,LLM大模型训练用数据集在线交易分享 - 渐风AI",
  },
  {
    path: "/service",
    element: <Service />,
    title: "AI服务,AI定制化,AI开发，人工智能服务外包 - 渐风AI",
  },
  {
    path: "/dataset_detail",
    element: <DatasetDetail />,
    title: "数据集详情 - 渐风AI",
  },
  {
    path: "/service_detail",
    element: <ServiceDetail />,
    title:
      "服务详情,人工智能博士招生，AI工作招聘,AIoffer,人工智能高级人才服务 - 渐风AI",
  },
  {
    path: "/industry_news",
    element: <IndustryNews />,
    title:
      "产业资讯,AI生态社区,人工智能行业动态,AI企业100强，AI企业10强,AI企业50强 - 渐风AI",
  },
  {
    path: "/industry_detail",
    element: <IndustryNewsDetail />,
    title: "资讯详情 - 渐风AI",
  },
  { path: "/login", element: <Login />, title: "登录 - 渐风AI" },
  {
    path: "/forgotpassword",
    element: <ForgotPassword />,
    title: "忘记密码 - 渐风AI",
  },
  // {
  //   path: "/recharge",
  //   element: <Recharge />,
  //   title: "充值 - 渐风AI",
  // },
  {
    path: "/personal/finance/bankcard",
    element: <BankCard />,
    title: "银行卡 - 渐风AI",
  },
  {
    path: "/personal/finance/bankcard/confirm",
    element: <BankCardConfirm />,
    title: "确认银行卡信息 - 渐风AI",
  },
  {
    path: "/personal/finance/verify",
    element: <Verify />,
    title: "实名认证 - 渐风AI",
  },
  {
    path: "/compute/pay-confirm",
    element: <PayConfirm />,
    title: "确认支付 - 渐风AI",
  },
  // { path: "*", element: <NotFound />, title: "页面未找到 - 渐风AI" },
];

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // 更新状态，以便在渲染中显示降级UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 你可以在这里记录错误信息，例如发送到错误报告服务
    console.error("Caught an error in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // 你可以自定义错误展示的内容
      return <h1>Something went wrong.</h1>;
    }

    return this.props.children;
  }
}

const HeaderWithLocation = React.memo(
  () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const pathsToHideHeader = ["/login", "/forgotpassword"];

    const shouldShowHeader = routes.some(
      (route) =>
        route.path === currentPath && !pathsToHideHeader.includes(currentPath)
    );

    return <div>{shouldShowHeader && <Header />}</div>;
  },
  (prevProps, nextProps) =>
    prevProps.location.pathname === nextProps.location.pathname
);

const Footer = () => {
  return (
    <div className="footer-container">
      <div className="food_top">
        <div className="food_logo">
          <img src={require("./img/jflogo.png")} alt="Logo" className="logo" />
        </div>
        <div className="food_pre">
          <div className="food_child">
            <div className="footer-content">
              <div>联系我们</div>
              <p>
                <a href="mailto:prbd@aijfeng.com">合作邮箱：prbd@aijfeng.com</a>
              </p>
              <p>
                <a href="mailto:feedback@aijfeng.com">
                  投诉建议：feedback@aijfeng.com
                </a>
              </p>
              <p>
                <a href="tel:010-64857116">联系电话：010-64857116</a>
              </p>
              <p>
                <a href="https://www.baidu.com">
                  地址：北京市丰台区马家堡东路156号
                </a>
              </p>
            </div>
          </div>
          <div className="food_child">
            <div className="footer-content">
              <div>AI产业活动</div>
              <p>
                <a
                  href="https://www.163.com/dy/article/JKEIFF170511PEBT.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  北京：CEAI 2025中国具身智能大会 2025.3.28-30
                </a>
              </p>
              <p>
                <a
                  href="https://mp.weixin.qq.com/s?__biz=MjM5MDUxNjI1NQ==&mid=2650361301&idx=1&sn=f8fceb3ee7e9d47d24f5ecb799351d6d&chksm=be4e78a58939f1b345769905b1d9f2d4251689de566a6f510eb42e8b6b292da5162d860c62c6&scene=27"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  天津：2025年具身智能机器人发展大会 2025.3.7
                </a>
              </p>
              <p>
                <a
                  href="https://www.worldaic.com.cn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  上海：世界人工智能大会 2025.6月（预计）
                </a>
              </p>
              <p>
                <a
                  href="https://www.agicexpo.com/?bd_vid=1462386112944800855"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  深圳：2025深圳（国际）通用人工智能大会 2025.8.27-29
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div>
        北京渐风科技有限公司版权所有◎2015-2025*北京市海淀区大柳树富海中心1208*
        京ICP备2025072988号-1
      </div>
    </div>
  );
};

const ContentWithFooter = () => {
  const location = useLocation();
  const currentPath = location.pathname;

  // 定义需要显示 Footer 的路径列表
  const pathsToShowFooter = [
    "/",
    "/home",
    // "/personal",
    // "/userInfor",
    "/videotutorials",
    "/video_detail",
    "/tutorial",
    "/tutorial_detail",
    "/papertutorials",
    "/paper_detail",
    "/computationaltrading",
    "/computa_detail",
    "/tool",
    "/dataset_list",
    "/service",
    "/dataset_detail",
    "/service_detail",
    "/industry_news",
    "/industry_detail",
  ];

  // 检查当前路径是否在需要显示 Footer 的路径列表中
  const shouldShowFooter = pathsToShowFooter.includes(currentPath);
  // 设置页面标题
  useEffect(() => {
    const currentRoute = routes.find(
      (route) => route.path === location.pathname
    );
    document.title = currentRoute?.title || "渐风AI";
  }, [location.pathname]);
  return (
    <div className="content-with-footer">
      <div className="content-body">
        <Routes>
          {routes.map((route) => (
            <Route
              key={route.path} // 使用路由路径作为key
              path={route.path}
              element={route.element}
            />
          ))}
        </Routes>
      </div>
      {shouldShowFooter && <Footer />}
    </div>
  );
};

// 创建一个包装组件来处理认证拦截器
const AuthWrapper = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    setupAuthInterceptor(navigate);
  }, [navigate]);

  return children;
};

const AppRouter = () => {
  useEffect(() => {
    document.title = "渐风AI";
  }, []);

  return (
    <Router>
      <AuthWrapper>
        <ErrorBoundary>
          <div className="app-container-foot">
            <HeaderWithLocation />
            <ContentWithFooter />
          </div>
        </ErrorBoundary>
      </AuthWrapper>
    </Router>
  );
};

export default AppRouter;
